import {NotifyPropertyChanged} from '../utils/NotifyPropertyChanged.js';
import {NotificationParams} from './NotificationParams.js';

export class MissionCompleteNotificationModel extends NotifyPropertyChanged {
    isVisible: boolean = false;
    message: string;
    messageDetail: string;

    get canShow(): boolean {
        return !this.isVisible;
    }

    private static _instance: MissionCompleteNotificationModel;

    static get instance(): MissionCompleteNotificationModel {
        if (!MissionCompleteNotificationModel._instance) {
            MissionCompleteNotificationModel._instance =
                new MissionCompleteNotificationModel();
        }
        return MissionCompleteNotificationModel._instance;
    }

    private constructor() {
        super();
    }

    show(message: string, messageDetail: string) {
        this.message = message;
        this.messageDetail = messageDetail;
        this.isVisible = true;
        this.notifyPropertyChanged('isVisible');
        setTimeout(() => {
            this.hide();
        }, 5500);
    }

    hide() {
        this.isVisible = false;
        this.notifyPropertyChanged('isVisible');
    }
}
